import { EMPTY_GUID } from '../models/common';
import { IOrderNotificationPreference } from '../models/order-notification-preference';
import { IResult } from '../models/result-models';
import { apiGet, apiPost } from './api-utils';

export const getOrderPreferences = async (
    guid?: string
): Promise<IResult<IOrderNotificationPreference[]>> => {
    const companyGuid = guid || EMPTY_GUID;
    const url =
        process.env.REACT_APP_API_URL +
        '/v1/companies/' +
        companyGuid +
        '/order-preferences';
    const result = apiGet<IOrderNotificationPreference[]>(url);

    return result;
};

export const saveOrderPreferences = async (
    preferences: IOrderNotificationPreference[],
    guid?: string
): Promise<IResult<boolean>> => {
    const companyGuid = guid || EMPTY_GUID;
    const url =
        process.env.REACT_APP_API_URL +
        '/v1/companies/' +
        companyGuid +
        '/order-preferences';
    const result = apiPost<IOrderNotificationPreference[], boolean>(
        url,
        preferences
    );

    return result;
};
